var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { filterFilesMatchingContent } from "@rentiohq/shared-frontend/dist/reduxV2/documents/document.utils";
import React from "react";
import { useDropzone } from "react-dropzone";
import { Dropzone, DropzonePlaceholder } from "../../components";
import { toast } from "../../managers/Toast";
import { ts } from "../../services";
import { showDropErrors } from "../../utils/file";
import { Icon } from "../Icon";
import { CameraModal } from "./CameraModal/CameraModal";
import { CameraButton } from "./UploadField.styles";
export var UploadField = function (props) {
    var id = props.id, name = props.name, onChange = props.onChange, _a = props.asDropzone, asDropzone = _a === void 0 ? true : _a, _b = props.multiple, multiple = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.maxFileSize, maxFileSize = _d === void 0 ? CONFIG.UPLOAD_MAX_FILE_SIZE : _d, _e = props.minFileSize, minFileSize = _e === void 0 ? CONFIG.UPLOAD_MIN_FILE_SIZE : _e, _f = props.accept, accept = _f === void 0 ? "*" : _f, required = props.required, error = props.error, fileName = props.fileName;
    var _g = React.useState(false), showCameraModal = _g[0], setShowCameraModal = _g[1];
    var handleDrop = function (acceptedFiles, fileRejections, event) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, valid, invalid;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    showDropErrors({
                        acceptedFiles: acceptedFiles,
                        fileRejections: fileRejections,
                        event: event,
                        maxFileSize: maxFileSize,
                        minFileSize: minFileSize,
                    });
                    if (acceptedFiles.length === 0) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, filterFilesMatchingContent(acceptedFiles)];
                case 1:
                    _a = _b.sent(), valid = _a.valid, invalid = _a.invalid;
                    invalid.forEach(function (_a) {
                        var file = _a.file, message = _a.message;
                        toast({ heading: file.name, variation: "error", content: message });
                    });
                    if (valid.length === 0) {
                        return [2 /*return*/];
                    }
                    onChange(valid);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (_a) {
        var acceptedFiles = _a.target.files;
        onChange(acceptedFiles);
    };
    var dropzoneProps = {
        onDrop: handleDrop,
        multiple: multiple,
        maxSize: maxFileSize,
        minSize: minFileSize,
        disabled: disabled,
    };
    // To accept all, just leave the 'accept' prop out.
    if (accept && accept !== "*")
        dropzoneProps.accept = accept;
    var _h = useDropzone(dropzoneProps), getRootProps = _h.getRootProps, getInputProps = _h.getInputProps, isDragActive = _h.isDragActive;
    var title = isDragActive
        ? ts.fileDropZoneDrop()
        : ts.fileDropZonePlaceholder();
    if (asDropzone)
        return (_jsxs(_Fragment, { children: [_jsxs(Dropzone, __assign({}, getRootProps(), { isDraggingOver: isDragActive, hasError: !!error, isEmpty: true, children: [_jsx("input", __assign({ id: id, name: typeof name === "string" ? name : undefined }, getInputProps())), _jsxs(DropzonePlaceholder, { children: [_jsxs("p", { children: [title, " "] }), fileName && (_jsx(CameraButton, { onClick: function (event) {
                                        event.stopPropagation();
                                        setShowCameraModal(true);
                                    }, children: _jsx(Icon, { size: "mediumLarge", source: "camera" }) }))] })] })), showCameraModal && (_jsx(CameraModal, { fileName: fileName || "File", getImage: onChange, showModal: showCameraModal, onClose: function () { return setShowCameraModal(false); } }))] }));
    return (_jsx("input", { id: id, name: typeof name === "string" ? name : undefined, required: required, type: "file", onChange: handleChange, defaultValue: "", multiple: multiple, accept: accept, disabled: disabled }));
};
